var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.667 5.667h22.666A2.842 2.842 0 0131.167 8.5v17a2.842 2.842 0 01-2.834 2.833H5.667A2.842 2.842 0 012.833 25.5v-17a2.842 2.842 0 012.834-2.833z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 8.5L17 18.417 2.833 8.5",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzQgMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjY2NjcxIDUuNjY2NjNIMjguMzMzNEMyOS44OTE3IDUuNjY2NjMgMzEuMTY2NyA2Ljk0MTYzIDMxLjE2NjcgOC40OTk5NlYyNS41QzMxLjE2NjcgMjcuMDU4MyAyOS44OTE3IDI4LjMzMzMgMjguMzMzNCAyOC4zMzMzSDUuNjY2NzFDNC4xMDgzNyAyOC4zMzMzIDIuODMzMzcgMjcuMDU4MyAyLjgzMzM3IDI1LjVWOC40OTk5NkMyLjgzMzM3IDYuOTQxNjMgNC4xMDgzNyA1LjY2NjYzIDUuNjY2NzEgNS42NjY2M1oiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMS4xNjY3IDguNUwxNyAxOC40MTY3TDIuODMzMzcgOC41IiBmaWxsPSIjZmZmZmZmIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgEmail as ReactComponent };